module.exports = __webpack_public_path__ + "img/jumpsuit side invisible zipper length.afb45ad5.png";